import { render } from "./average-response-time.vue?vue&type=template&id=249902ac"
import script from "./average-response-time.vue?vue&type=script&lang=ts"
export * from "./average-response-time.vue?vue&type=script&lang=ts"

import "./average-response-time.vue?vue&type=style&index=0&id=249902ac&lang=less"
script.render = render

export default script